'use strict';

module.exports = [
  {
    messageKey: 'js.modules.signup.enter_full_name',
    validateFn: value => !!value,
  },
];
